import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "row justify-content-center m-2 p-2"
}
const _hoisted_3 = { class: "row m-2 bg-light" }
const _hoisted_4 = { class: "border-1" }
const _hoisted_5 = {
  key: 0,
  class: "border-1"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "border-1"
}
const _hoisted_8 = { class: "border-1" }
const _hoisted_9 = { class: "border-1" }
const _hoisted_10 = { class: "border-1" }
const _hoisted_11 = { class: "container mt-2" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "container" }, [
        _createElementVNode("span", { class: "h1 row align-center" }, " Schedule View")
      ], -1)),
      (!$setup.loggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", { class: "h1 text-danger" }, " You first need to log into your account.", -1)
          ]))]))
        : _createCommentVNode("", true),
      ($setup.loggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
              class: "col-3 m-0 p-0 datepicker",
              type: "date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.SelectedStartDate) = $event)),
              placeholder: "Start Date"
            }, null, 512), [
              [_vModelText, $setup.SelectedStartDate]
            ]),
            _withDirectives(_createElementVNode("input", {
              class: "col-3 m-0 p-0 datepicker",
              type: "date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.SelectedEndDate) = $event)),
              placeholder: "End Date"
            }, null, 512), [
              [_vModelText, $setup.SelectedEndDate]
            ]),
            _createElementVNode("button", {
              class: "col-3 col-sm-3 btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.GetOfficerSchedule(0)))
            }, " Search ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", null, [
        _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "border-1" }, [
            _createElementVNode("th", { class: "col-1 border-1 text-center" }, "SN"),
            _createElementVNode("th", { class: "col-1 border-1 text-center" }, "Accept?"),
            _createElementVNode("th", { class: "col-3 border-1 text-center" }, "Date"),
            _createElementVNode("th", { class: "col-3 border-1 text-center" }, "Timings"),
            _createElementVNode("th", { class: "col-4 border-1 text-center" }, "Site")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.Jobs, (job, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: job.scheduleViewModel.jobId
            }, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(($setup.currentPageNo * $setup.recordsPerPage) + index+1), 1),
              ($setup.isJobAcceptanceRequired(job.scheduleViewModel.statusId))
                ? (_openBlock(), _createElementBlock("td", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "btn btn-danger m-2",
                      onClick: ($event: any) => ($setup.AcceptJob(job.scheduleViewModel.jobId))
                    }, " Yes ", 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true),
              (!$setup.isJobAcceptanceRequired(job.scheduleViewModel.statusId))
                ? (_openBlock(), _createElementBlock("td", _hoisted_7, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("span", null, [
                      _createElementVNode("img", { src: "TickNew.png" })
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createElementVNode("td", _hoisted_8, _toDisplayString($options.dateToYYYYMMDD(job.jobDate)), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(job.scheduleViewModel.startTime.substring(11, 16)) + "-" + _toDisplayString(job.scheduleViewModel.endTime.substring(11, 16)), 1),
              _createElementVNode("td", _hoisted_10, _toDisplayString(job.scheduleViewModel.siteInfo), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("button", {
          class: "Btn btn-primary btn-sm m-1",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.GetOfficerSchedule($setup.startPageNumber - $setup.LabelsPerPage)))
        }, " << ", 512), [
          [_vShow, $setup.isRangeLess_Than_TotalResultPages]
        ]),
        ($setup.endPageNumber > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.endPageNumber, (pageNo) => {
                return (_openBlock(), _createElementBlock("span", { key: pageNo }, [
                  ($setup.isShownPageButton(pageNo))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(["btn btn-success btn-sm m-1", $setup.selectedPageClass(pageNo)]),
                        type: "button",
                        onClick: ($event: any) => ($setup.GetOfficerSchedule(pageNo - 1))
                      }, _toDisplayString(pageNo), 11, _hoisted_13))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _withDirectives(_createElementVNode("button", {
                type: "button",
                class: "Btn btn-primary btn-sm m-1",
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.GetOfficerSchedule($setup.endPageNumber)))
              }, " >> ", 512), [
                [_vShow, $setup.isRangeGreater_Than_LabelsPerPage]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}